import { render } from "./footerTeaser.vue?vue&type=template&id=50e9010b"
import script from "./footerTeaser.vue?vue&type=script&lang=js"
export * from "./footerTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__